export const LIST_REVIEWS = [
  {
    title: 'Tomer Nachmias',
    text: 'עושים עבודת קודש ממליץ בחום הזמנתי אותם לפני שבועיים הגיעו עשו תעבודה מכל הלב',
    link: 'https://www.facebook.com/bezikaron/reviews',
  },
  {
    title: 'ברוך פרץ',
    text: 'מנסיון איתם עושים עבודה ייסודית וטובה ממליץ בחום!!!! תודה לכם!',
  },
  {
    title: 'יפה סילברה',
    text: 'עושים עבודההה מצויינת מכל הלב אין כמוכם',
  },
  {
    title: 'רחלי קרביץ-ארגז',
    text: 'עבודה מעולה. אנשים מדהימים. ממליצה בחום.',
  },
  {
    title: 'Nurit Zipel Hofmaister',
    text: 'עבודה טובה יחס טוב תודה רבה יצאתי מאוד מרוצה ממליצה בחום',
  },
  {
    title: 'Dmitry Mirezky',
    text: 'חברה ממש הגונה שעושה עבודת קודש! עושים עבודה מעולה ומחייבים רק אחרי תמונות סופיות. ממליץ לכל המתלבטים וספקניים.',
  },
  {
    title: 'ארז הרשקוביץ',
    text: 'חייב להודות ולפרגן. רצינות מקצועיות ועבודה יפה . המון תודות . שיפצו לנו מצבה בת 36 שנה...כל הכבוד.',
  },
];
